// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div[data-v-7f15827b] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n}\n.video-js[data-v-7f15827b] {\n  width: 100% !important;\n  height: 100% !important;\n  padding: 0 !important;\n}\n.video-container[data-v-7f15827b] {\n  height: 100%;\n  width: 100%;\n}\n.video-container video[data-v-7f15827b] {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n     object-fit: contain;\n}", ""]);
// Exports
module.exports = exports;
